import script from "./FullScreenModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FullScreenModal.vue?vue&type=script&setup=true&lang=js"

import "./FullScreenModal.vue?vue&type=style&index=0&id=464feccc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-464feccc"]])

export default __exports__